import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import decode from 'jwt-decode';
import { AuthenticationService } from '../_services/authentication.service';
import { AccountService } from '../_services/account.service';
import { TWADialogsService } from '../_services/twa-dialogs.service';

@Injectable()
export class RoleGuard  {

    userData: any;

    constructor(
        public router: Router,
        public auth: AuthenticationService,
        public accountSvc: AccountService,
        private dlgsSvc: TWADialogsService,
        private authSvc: AuthenticationService,
    ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    // this will be passed from the route config
    // on the data property
    const expectedRole = +route.data.expectedRole;

    const api_key = localStorage.getItem('api_key');
    let userData: any;

    if (api_key > '') {
        console.log(api_key);
        try {
            userData = decode(api_key);
        } catch (error) {
            console.log('ROLE GUARD DECODE ERROR:', error);
            this.dlgsSvc.confirm(
                'Token Inválido',
                'Tu token de sesión es inválido o está corrupto.\n\nSerás redirigido al login para iniciar sesión nuevamente.',
                'Ir al Login'
            ).subscribe(() => {
                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            });
            return false;
        }
        this.userData = userData;
        this.auth.user = userData;
        console.log(userData);
        console.log('expectedRole',expectedRole);
        // Usar 'nivel' si existe, sino 'level' 
        // En este sistema: nivel más bajo = más permisos (nivel 1 = administrador)
        const userLevel = userData.nivel || userData.level;
        if (userLevel <= expectedRole) {
            console.log(route.data);
            if (typeof route.data.expectedModule !== 'undefined') {
                console.log(this.accountSvc.products);
                return this.accountSvc.products.filter((product) => {
                    console.log(+product.id, +route.data.expectedModule);
                    return +product.id === +route.data.expectedModule;
                }).length > 0;
                // return this.accountSvc.data.products.filter((product) => {
                //     console.log(+product.id, +route.data.expectedModule);
                //     return +product.id === +route.data.expectedModule;
                // }).length > 0;
            } else {
                return true;
            }
        } else {
            // Mostrar diálogo de error de permisos
            this.authSvc.logout();
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }
    } else {
        // Mostrar diálogo de sesión no válida
        this.dlgsSvc.confirm(
            'Sesión No Válida',
            'Tu sesión ha expirado o no tienes una sesión activa.\n\nSerás redirigido al login.',
            'Ir al Login'
        ).subscribe(() => {
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        });
        return false;
    }

    return true;
  }

}
